import { useEffect, useState } from 'react';
import { getBellSchedules, type BellSchedule } from 'services/api';
import { getColumns } from './columns';

export const useBellSchedulesTable = () => {
  const [bellSchedules, setBellSchedules] = useState<BellSchedule[]>([]);

  const refreshTable = () => {
    getBellSchedules().then((res) => {
      setBellSchedules(res);
    });
  };

  useEffect(() => {
    getBellSchedules().then((res) => {
      setBellSchedules(res);
    });
  }, []);

  const columns = getColumns({
    refreshTable,
  });

  return {
    state: {
      dataSource: bellSchedules,
      columns,
    },
    methods: { refreshTable },
  };
};
